<script>
    import {getStyleValue} from "../../Common/tools";

    export let data, globalStyle, isChild = false;
</script>
{#if isChild}
    <table class="component-center" cellspacing="0" cellpadding="0" bgcolor="{data.style.couponBackgroundColor}"
           align="{data.style.position}">
        <tbody>
        <tr>
            <th style="border: 1px dashed #969AA1; border-radius: 3px; color: {data.style.color}; display: inline-block; font-size: 14px; font-weight: 400; padding: 15px 50px 15px 50px;" class="email-button">
              {data.code}
            </th>
        </tr>
        </tbody>
    </table>
{:else}
    <tr>
        <th class="column"
            style="padding-left: 30px; padding-right: 30px; font-weight: 400; text-align: left;"
            width="{getStyleValue(globalStyle.width, 600)}">
            <table class="component-center" cellspacing="0" cellpadding="0" bgcolor="{data.style.couponBackgroundColor}"
                   align="{data.style.position}">
                <tbody>
                <tr>
                    <th style="border: 1px dashed #969AA1; border-radius: 3px; color: {data.style.color}; display: inline-block; font-size: 14px; font-weight: 400; padding: 15px 50px 15px 50px;" class="email-button">
                      {data.code}
                    </th>
                </tr>
                </tbody>
            </table>
        </th>
    </tr>
{/if}



